import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { DocumentService } from '../services/document.service';
import { MatSnackBar } from '@angular/material';
import { CourseUnitsService } from '../services/course-units.service';
import { UserRoleService } from '../services/user-role.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {


  @Input('jobId') singleJobId;
  @Input('singleJob') jobDetails;
  @Input('learners') learnersList
  @Input('units') unitList
  @Input('assignment') listOfAssignment
  @Input('jobEdit') editJob
  @Input('learnerArray') learnerArray
  jobId
  documentData
  singleJob
  sendJob
  allLearners = []
  unitsList = []
  courseIdForUnits;
  assignmentList = []
  courseType
  loading
  isEditJob
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public documentService: DocumentService,
    public _snackBar: MatSnackBar,
    public unitService: CourseUnitsService,
    public _userRoleService: UserRoleService
  ) { }

  ngOnInit() {
    console.log("learnerArray--->", this.learnerArray);

  }



  ngOnChanges(changes: SimpleChanges): void {

    if (changes.singleJobId && changes.singleJobId.currentValue) {
      this.jobId = changes.singleJobId.currentValue
      this.getDocumentDetails()
    }

    if (changes.jobDetails && changes.jobDetails.currentValue) {
      let objLength = Object.keys(changes.jobDetails.currentValue).length
      console.log("Changes in job", changes.jobDetails, objLength);
      if (objLength != 0) {
        this.singleJob = changes.jobDetails.currentValue
        console.log("single job details==========", this.singleJob);
        this.courseType = this.singleJob.course.type
        this.courseIdForUnits = this.singleJob.course._id
        this.getUnits()
        this.getUserRole();
      }
    }
    if (changes.learnersList && changes.learnersList.currentValue) {
      console.log("what is the total learners list=================", changes.learnersList.currentValue);
      this.allLearners = changes.learnersList.currentValue
    }

    if (changes.listOfAssignment && changes.listOfAssignment.currentValue) {
      console.log("when this page is called for documents", changes.listOfAssignment);
      let assignment = changes.listOfAssignment.currentValue
      assignment.forEach((obj, index) => {
        this.assignmentList = this.assignmentList.concat(obj.assignment)
        console.log("this.assignmentsForPdf=========", this.assignmentList)

      })
    }
    if (changes.editJob && changes.editJob.currentValue) {
      this.isEditJob = changes.editJob.currentValue
    }

    // if (changes.unitList && changes.unitList.currentValue) {
    //   this.unitsList = changes.unitList.currentValue
    // }

  }
  getUserRole() {
    console.log("this user role data document==>", this.singleJob)
    let getRole = this._userRoleService.getUserRole(this.singleJob.instructors, 'job');
    console.log("get role data", getRole);

    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }


  // UTILITY



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }





  iqaFormDetails(event) {
    console.log("event of form", event);

    this.documentService.getIqaData(event)


  }

  // API Calls

  getDocumentDetails() {
    this.loading = true
    let obj = {
      jobId: this.jobId,
      title: 'GP'
    }
    console.log("document JobId==>", obj);

    this.documentService.getDocumentDetails(this.jobId).subscribe((res: any) => {
      console.log("response of single document data", res, this.jobId);
      if (res) {
        this.documentData = res[0]
        this.sendJob = this.singleJob
        console.log("response of any particular job", this.documentData);
        this.loading = false
      }
    }, error => {
      console.log("error while get document details", error);
      this.loading = false

    })

  }





  gpFormValue(event) {
    this.loading = true
    console.log("gp form value in main page", event);
    this.documentService.updateForm(event).subscribe((response) => {
      console.log("response of form update", response);
      this.documentData = response;
      this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
      this.loading = false
    }, err => {
      console.log("error while update form", err);
      this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      this.loading = false

    })


  }




  getUnits() {
    this.loading = true
    console.log("what is the course id", this.courseIdForUnits);
    // console.log("what is the value of dedfault vaar=======", this.defaultUnit);

    this.unitService.getUnits(this.courseIdForUnits).subscribe(res => {
      this.unitsList = res;
      console.log("units list by course id", this.unitsList)
      this.loading = false
    })
  }
  getAssignment(data) {
    console.log("total assignment list====================", JSON.parse(data));

  }


}
